import axios from "axios";
import packageJson from "../../../package.json";
import { get_accessToken, get_customerPannel_type, get_Id, get_lang, get_refreshToken, set_accessToken } from "../../helper/UserData/userdate";

export const httpCustomer = axios.create({
  baseURL: global.config.restServerUrl,
  timeout: 20000,
  headers: {
    "Accept-Language": get_lang(),
    Authorization: "Bearer " + get_accessToken(),
  }
});

httpCustomer.defaults.headers.common["retry"] = 2;
httpCustomer.defaults.headers.common["retryDelay"] = 3000;
httpCustomer.defaults.headers.common["retryCount"] = 0;
httpCustomer.defaults.headers.common["X-Api-Source"] = 'web';
httpCustomer.defaults.headers.common["X-App-Version-Code"] = packageJson.version;
httpCustomer.defaults.headers.common["X-App-Version-Name"] = packageJson.version;

httpCustomer.interceptors.request.use(
  (config) => {
    const token = "Bearer " + get_accessToken()
    if (token) {
      // config.headers["Authorization"] = 'Bearer ' + token;  // for Spring Boot back-end
      config.headers["Authorization"] = token; // for Node.js Express back-end
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

httpCustomer.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    
    const originalConfig = err.config;


    if (err.response && err.response.status === 401 && err.response.data.code == "-9") {
            // Access Token was expired
            if (!originalConfig._retry) {
              originalConfig._retry = true;
      
              try {
                const rs = await httpCustomer.post(`/api/v1/customer/${get_customerPannel_type() == "individual" ? "individual" : "business"}/auth/token`, {
                       customerId: get_Id(),
                       refreshToken: get_refreshToken(),
                });
      
 
                set_accessToken(rs.data.data.accessToken);
 
 
                return httpCustomer(originalConfig);
              } catch (_error) {
                return Promise.reject(_error);
              }
            }
    }else{
     
     
    }



    

    return Promise.reject(err);
  }
);
